<div class="text-paragraph">

  @if (loading) {
    <hpo-placeholder
    type="row"></hpo-placeholder>
  }

  @if (!loading) {
    <div
      class="text-paragraph__content"
    [innerHTML]="sanitizedHtml"></div>
  }

</div>